import React, { useMemo } from 'react';

import Spinner from '@components/Spinner';
import OrgChartsGridItem from '@components/pages/OrgCharts/GridItem';
import gridStyles from '@components/pages/OrgCharts/styles.module.scss';
import useEventTracking from '@hooks/useEventTracking';
import useRecentlyUpdatedOrgCharts from '@hooks/useRecentlyUpdatedOrgCharts';
import { org_charts_path } from '@routes';
import { ClickTarget, TrackingLocation, click } from '@tracking';

import MyTISection from './Section';
import { MY_TI_ENGAGEMENT_LABELS, MY_TI_SECTION_IDS, VIEW_ALL_ORG_CHARTS } from './constants';
import useRegisterSection from './useRegisterSection';

const MyTIOrgCharts = () => {
  const { trackEvent } = useEventTracking({
    location: TrackingLocation.OrgChartMoreOrgChartsGrid,
  });

  const { orgCharts, isLoading } = useRecentlyUpdatedOrgCharts();

  const orgChartsDisplayText = useMemo(() => {
    if (!orgCharts) return MY_TI_ENGAGEMENT_LABELS.NotEngaged.Pro.OrgCharts;
    return MY_TI_ENGAGEMENT_LABELS.Engaged.Pro.OrgCharts;
  }, [orgCharts]);

  useRegisterSection(MY_TI_SECTION_IDS.OrgCharts, isLoading || !!orgCharts);

  if (!isLoading && !orgCharts) return null;

  const handleViewAllClick = () => {
    trackEvent(click({ clickTarget: ClickTarget.AnchorLink, clickText: VIEW_ALL_ORG_CHARTS }));
  };

  return (
    <MyTISection
      id={MY_TI_SECTION_IDS.OrgCharts}
      highlight={orgChartsDisplayText.label}
      subtitle={orgChartsDisplayText.subtitle}
      title={orgChartsDisplayText.title}
    >
      {!isLoading && orgCharts ? (
        <div className="mt-32 flex flex-col items-start gap-32">
          <div
            className={`grid w-full grid-cols-2 gap-0 sm:grid-cols-4 ${gridStyles['unique-org-grid']}`}
          >
            {orgCharts.map((company) => (
              <OrgChartsGridItem key={company.id} company={company} />
            ))}
          </div>
          <a
            className="font-suisse-intl text-body-lg underline transition-colors duration-150 hover:text-primary-magenta"
            href={org_charts_path()}
            onClickCapture={handleViewAllClick}
          >
            {VIEW_ALL_ORG_CHARTS}
          </a>
        </div>
      ) : (
        <div className="grid w-full place-items-center">
          <Spinner marginY="small" />
        </div>
      )}
    </MyTISection>
  );
};

export default MyTIOrgCharts;
